import { TypeIdSchema, apiKey } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const ApiKeySchema = createSelectSchema(apiKey);

export const InsertApiKeySchema = createInsertSchema(apiKey);

export const PublicApiKeySchema = Type.Object({
  object: Type.Literal('ApiKey', { description: 'The type of the returned object.' }),
  id: TypeIdSchema('apiKey', { description: 'The unique public ID of the API Key.' }),
  application_id: TypeIdSchema('app', { description: 'The ID of the Application that owns the API Key.' }),
  prefix: Type.String({ description: 'The non-secret prefix used to identify the API Key.' }),
  issued_at: Type.String({ description: 'The date and time when the API Key was created.' }),
  expires_at: Type.String({ description: 'The date and time when the API Key expires.' }),
  name: Type.String({ description: 'The internal name of the API Key.' }),
  role: Type.Union([Type.Literal('service'), Type.Literal('account'), Type.Literal('scoped')], {
    description:
      'The effective access role: `service` manages the Application, `account` accesses every Account, and `scoped` accesses one Scope.',
  }),
  account_scope_id: Type.Union([TypeIdSchema('accountScope'), Type.Null()], {
    description: 'The Scope accessible to the API Key, or `null` for service and global Account API Keys.',
  }),
});

export type ApiKey = typeof apiKey.$inferSelect;
export type InsertApiKey = typeof apiKey.$inferInsert;
export type PublicApiKey = Static<typeof PublicApiKeySchema>;
